<template>
    <div>
        <rkm-row v-if="!data.form.pacienteAtingiu24horas">
            <rkm-col>
                <rkm-alert color="info">
                    Em observação há {{ data.form.tempoEmObservacao }}.
                </rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row v-else>
            <rkm-col>
                <rkm-alert
                    class="mt-2"
                    color="danger"
                >
                    Paciente atingiu 24 horas em observação às {{ data.form.tempoEmObservacao }}.
                </rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col align-self="center">
                <p class="m-0 p-0">
                    <strong>Data/hora de entrada Observação:</strong> {{ data.form.entradaObservacao }}
                </p>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.quarto"
                    label="Quarto"
                    v-model="data.model.quarto"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.leito"
                    label="Leito"
                    v-model="data.model.leito"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row class="mb-4">
            <rkm-col cols="auto">
                <p class="m-0 p-0">
                    <strong>Aguardando vaga hospitalar:</strong>
                </p>
            </rkm-col>
            <rkm-col cols="8">
                <rkm-form-radio-group
                    v-model="data.model.aguardandoVagaHospitalar"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col>
                <rkm-button
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('prescricao-interna')"
                    :outline="data.form.prescricoesInterna.length || data.model.prescricoesInterna.length ? false : true"
                >
                    Prescrição interna
                </rkm-button>

                <rkm-button
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('exame-Laboratorial')"
                    :outline="data.form.pedidosExames.length ? false : true"
                >
                    Exames imagem/laboratoriais
                </rkm-button>

                <rkm-button
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('servico-enfermagem')"
                    :outline="data.form.servicosEnfermagem.length
                        || data.model.servicosEnfermagem.length ? false : true"
                >
                    Serviços de enfermagem
                </rkm-button>

                <rkm-button
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('anotacao-enfermagem')"
                    :outline="data.form.atendimentoEnfermagem.anotacoes.length
                        || data.model.anotacoes.length ? false : true"
                >
                    Anotações de enfermagem
                </rkm-button>

                <rkm-button
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('atendimento-enfermagem')"
                    :outline="checkOutline"
                >
                    Atendimento de enfermagem
                </rkm-button>

                <rkm-button
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('sinal-vital')"
                    :outline="data.form.sinaisVitais.length || data.model.sinaisVitais.length ? false : true"
                >
                    Sinais vitais
                </rkm-button>

                <rkm-button
                    v-if="data.form.atendimentoMedico.evolucoes.length > 0"
                    color="primary"
                    class="mb-2"
                    @click="scrollTo('evolucao-medica')"
                    :outline="data.form.atendimentoMedico.evolucoes.length ? false : true"
                >
                    Evolução médica
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                leito: { max: 5 },
                quarto: { max: 5 },
            }
        },
        checkOutline() {

            var outline = true

            if (this.data.form.atendimentoEnfermagem.avaliacoes.length
                || this.data.form.atendimentoEnfermagem.historicos.length
                || this.data.form.atendimentoEnfermagem.diagnosticos.length
                || this.data.form.atendimentoEnfermagem.implementacoes.length
                || this.data.form.atendimentoEnfermagem.planejamentos.length
                || this.data.form.atendimentoTriagem.outrasAvaliacoesCondicoes.length
                || this.data.model.avaliacao !== null
                || this.data.model.diagnostico !== null
                || this.data.model.historico !== null
                || this.data.model.implementacao !== null
                || this.data.model.planejamento !== null
            ){

                outline = false
            } else {

                outline = true
            }

            return outline
        },
    },
    methods: {
        scrollTo(section) {
            const element = document.querySelector(`#${section}`)

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>